import useAppVariant from "features/common/hooks/useAppVariant";

export default function useShowAccountTypeFieldByVariant() {
  const appVariant = useAppVariant();

  const valuesByVariant = {
    seneca: true,
    senecaPrimary: false,
    plurall: true,
    goStudentLearning: false
  };

  return valuesByVariant[appVariant];
}
